(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/pullAt', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/pullAt'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.pullAt, global.convert);
    global.pullAt = mod.exports;
  }
})(this, function (exports, _pullAt2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.pullAt = undefined;

  var _pullAt3 = _interopRequireDefault(_pullAt2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * Replaces an array removing the specified indexes from the former array.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {...(number|number[])} [indexes] The indexes of elements to remove.
   * @return {Object} Returns the updated object.
   * @example pullAt({ nested: { prop: [4, 3, 2, 1] } }, 'nested.prop', 1, 3) // => { nested: { prop: [4, 2] } }
   * @see {@link https://lodash.com/docs#pullAt|lodash.pullAt} for more information.
   * @since 0.3.0
   */
  var pullAt = (0, _convert.convert)(function (array, predicate) {
    (0, _pullAt3.default)(array, predicate);
    return array;
  });
  exports.pullAt = pullAt;
  exports.default = pullAt;
});